module.exports = __webpack_public_path__ + "img/596967a6-c1a4-ade3-2e62-5ab4c84702ee.jpg";